import React, { useEffect, useState } from 'react'
import { Search, X, Check } from 'lucide-react'
import { translations } from '../../utils/constants'

const SearchIpAddresses = ({ selectedIpAddresses, handleIpAddressChange, ipAddresses, setSearchModal, searchModal, language, selectedFilter, setIPCount }) => {
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedIps, setSelectedIps] = useState(selectedIpAddresses || [])

    useEffect(() => {
        setIPCount(selectedIps?.length || 0)
    }, [selectedIps])

    useEffect(() => {
        if (!searchModal) {
            setSearchQuery('')
        }
    }, [searchModal])

    const filteredIps = ipAddresses?.filter((ip) =>
        ip.ip_address?.toLowerCase()?.includes(searchQuery.toLowerCase())
    )

    const handleIpSelection = (ip) => {
        const isSelected = selectedIps?.includes(ip)
        let updatedIps
        if (isSelected) {
            updatedIps = selectedIps?.filter(id => id !== ip)
        } else {
            updatedIps = [...selectedIps, ip]
        }
        setSelectedIps(updatedIps)
        handleIpAddressChange(updatedIps)
    }

    const handleSelectAll = () => {
        if (selectedIps?.length > 1) {
            setSelectedIps([])
            handleIpAddressChange([])
        }
        else {
            const allIpAddresses = ipAddresses?.map(ip => ip?.ip_address)
            setSelectedIps(allIpAddresses || [])
            handleIpAddressChange(allIpAddresses || [])
        }
    }

    const onSearchChange = (event) => {
        setSearchQuery(event.target.value)
    }

    const closeIpModal = () => {
        setSearchModal(false)
    }

    return (
        <div className='search-organization-container'>
            <span className='close-icon-search' onClick={closeIpModal}><X /></span>
            <div className='search-organization-header'>
                <h1>{translations[language]?.validator}</h1>
            </div>

            <div className='search-inner-div search-input-div2' style={{ margin: '0px' }}>
                <Search className='search-icon' />
                <input
                    type='text'
                    placeholder={translations[language]?.searchIpAddresses}
                    value={searchQuery}
                    onChange={onSearchChange}
                    className='search-input'
                />
            </div>

            <div className='organizations-header'>
                <div className='organization-search-text'>{translations[language]?.ipAddress}</div>
                <div onClick={handleSelectAll} className='select-all-button'>
                    {selectedIps?.length > 1 ? `${translations[language]?.clearAll}` : `${translations[language]?.selectAll}`}
                </div>
            </div>

            <div className='organizations-list-div'>
                <div className='organizations-list'>
                    {filteredIps?.map((ip) => (
                        <div
                            key={ip.ip_address}
                            onClick={() => handleIpSelection(ip.ip_address)}
                            className={`organization-item ${selectedIps.includes(ip.ip_address) ? 'selected' : ''}`}
                        >
                            <div className='checkbox'>
                                {selectedIps?.includes(ip?.ip_address) && <Check className='check-icon' />}
                            </div>
                            <div >
                                <div>
                                    <div className='organization-name capitalized-name'>{ip.ip_address}</div>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>

                {filteredIps?.length === 0 && <div className='no-results'>
                    {translations[language]?.noIpAddressesFound}
                </div>}
            </div>
        </div>
    )
}

export default SearchIpAddresses
